'use strict'

import RouteInternalAuditMixin from "@/mixins/RouteInternalAuditMixin";
import store from "@/store";
import Swal from "sweetalert2";
import RouteCompanyInternalAuditMixin from "@/mixins/RouteCompanyInternalAuditMixin";
import {TOKEN_NAME} from "@/services/ConstantService";
const VesselAuditMain = () => import('@/components/modules/ia/vessel/VesselAuditMain.vue')
const InternalAudit = () => import('../views/InternalAudit.vue')
const AuditorList = () => import('../components/modules/ia/auditor/AuditorList.vue')
const AuditorDPList = () => import('../components/modules/ia/auditor/AuditorDPList.vue')
const CompanyList = () => import( "@/components/modules/ia/company/CompanyList.vue");
const VesselAuditHistory = () => import( "@/components/modules/ia/vessel/VesselAuditHistory.vue");
const VesselAuditChecklist = () => import( "@/components/modules/ia/vessel/VesselAuditChecklist.vue");
const AppointmentDetails = () => import( "@/components/modules/ia/vessel/AppointmentDetails.vue");
const VesselAudit = () => import('../views/VesselAudit.vue')
const CompanyAudit = () => import('../views/CompanyAudit.vue')
const VesselList = () => import( "@/components/modules/ia/vessel/VesselList.vue");
const VPIMain = () => import( "@/components/modules/ia/vpi/VPIMain");
const VPIIntroduction = () => import( "@/components/modules/ia/vpi/SubComponents/VPIIntroduction.vue");
const VPIGraph = () => import( "@/components/modules/ia/vpi/SubComponents/VPIGraph.vue");
const VPI = () => import( "@/components/modules/ia/vpi/SubComponents/VPI.vue");
const VesselAuditDue = () => import( "@/components/modules/ia/vessel/VesselAuditDue.vue");
const AuditorProfile = () => import('@/components/modules/ia/auditor/AuditorProfile.vue')
const InternalAuditReport = () => import('@/components/modules/ia/vessel/InternalAuditReport.vue')
const NonConformity = () => import('@/components/modules/ia/vessel/NonConformity.vue')

const NcrMainDetails = () => import('@/components/modules/ia/vessel/nonConformity/details/NcrMainDetails')
const ObjectiveEvidenceDetail = () => import('@/components/modules/ia/vessel/nonConformity/details/ObjectiveEvidenceDetail')

const OEMainDetails = () => import('@/components/modules/ia/vessel/nonConformity/details/ObjectiveEvidenceDetail/OESubComponents/OEMainDetails');
const OEAttachments = () => import('@/components/modules/ia/vessel/nonConformity/details/ObjectiveEvidenceDetail/OESubComponents/OEAttachments');
const IaCompanyInstructions = () => import('@/components/modules/ia/vessel/nonConformity/details/ObjectiveEvidenceDetail/OESubComponents/IaCompanyInstructions');


const ObjectiveEvidenceList = () => import('@/components/modules/ia/vessel/ObjectiveEvidenceList.vue');
const IAShipParticular = () => import('@/components/modules/ia/vessel/IAShipParticular.vue');
const IaAttachment = () => import('@/components/modules/ia/vessel/IaAttachment.vue')
const IaCorrectiveActionReport = () => import('@/components/modules/ia/vessel/IaCorrectiveActionReport.vue')


// COMPANY AUDIT COMPONENTS

const CompanyAuditMain = () => import('@/components/modules/ia/company/CompanyAuditMain.vue')
const CompanyObjectiveEvidenceList = () => import('@/components/modules/ia/company/CompanyObjectiveEvidenceList');
const CompanyAuditDue = () => import('@/components/modules/ia/company/CompanyAuditDue');
const CompanyInternalAuditReport = () => import('@/components/modules/ia/company/CompanyInternalAuditReport.vue');
const CompanyNonConformity = () => import('@/components/modules/ia/company/CompanyNonConformity.vue')
const CompanyNcrMainDetails = () => import('@/components/modules/ia/company/nonConformity/details/CompanyNcrMainDetails')
const CompanyObjectiveEvidenceDetail = () => import('@/components/modules/ia/company/nonConformity/details/CompanyObjectiveEvidenceDetail')
const CompanyOEMainDetails = () => import('@/components/modules/ia/company/nonConformity/details/ObjectiveEvidenceDetail/OESubComponents/CompanyOEMainDetails');
const CompanyOEAttachments = () => import('@/components/modules/ia/company/nonConformity/details/ObjectiveEvidenceDetail/OESubComponents/CompanyOEAttachments');
const CompanyIaCompanyInstructions = () => import('@/components/modules/ia/company/nonConformity/details/ObjectiveEvidenceDetail/OESubComponents/CompanyIaCompanyInstructions');
const CompanyIaCorrectiveActionReport = () => import('@/components/modules/ia/company/CompanyIaCorrectiveActionReport')
const CompanyIAShipParticular = () => import('@/components/modules/ia/company/CompanyIAShipParticular');

export const RouteInternalAudit = {
  path: 'ia/',
  name: 'InternalAudit',
  redirect: 'ia/auditor',
  component: InternalAudit,
  children: [
    {
      path: 'auditor/',
      name: 'AuditorList',
      component: AuditorList,
    },
    {
      path : 'auditor/:id',
      name : 'AuditorProfile',
      component: ()=> import('@/components/modules/ia/auditor/AuditorProfile.vue'),
      children: [
        {
          path: 'general',
          name : 'AuditorGeneralInfo',
          component: () => import('@/components/modules/ia/auditor/AuditorGeneralInfo.vue')
        },
        {
          path: 'audit-history',
          name : 'AuditorAuditHistory',
          component: () => import('@/components/modules/ia/auditor/AuditorAuditHistory.vue'),
        },
        {
          path: 'dp-certificate',
          name : 'AuditorDesignatedPersonCertificateInfo',
          component: () => import('@/components/modules/ia/auditor/AuditorDesignatedPersonCertificateInfo.vue'),
        }
      ]
    },
    {
      path: 'dp-list/',
      name: 'AuditorDPList',
      component: AuditorDPList,
    },
    {
      path: 'vpi-status/',
      name: 'VPIMain',
      component: VPIMain,
      children: [
        {
          path: 'introduction',
          name: 'VPIIntroduction',
          component: VPIIntroduction,
        },
        {
          path: 'graph',
          name: 'VPIGraph',
          component: VPIGraph,
        },
        {
          path: 'vpi',
          name: 'VPI',
          component: VPI,
        },
      ]
    },
    {
      path : 'vessel-audit/',
      name : 'VesselAudit',
      component : VesselAudit,
      children: [
        {
          path: 'vessels/',
          name: 'VesselList',
          component: VesselList,
        },
        {
          path: 'objective-evidence/list',
          name: 'ObjectiveEvidenceList',
          component: ObjectiveEvidenceList
        },
        {
          path: 'audit-due/',
          name: 'VesselAuditDue',
          component: VesselAuditDue,
        },
        {
          path : 'vessels',
          name : 'VesselAuditRecordMain',
          component: ()=> import('@/components/modules/ia/vessel/VesselAuditRecordMain.vue'),
          children: [
            {
              path : ':vessel_id/audit',
              name : 'VesselAuditRecordList',
              component: ()=> import('@/components/modules/ia/vessel/VesselAuditRecordList.vue'),
            },
            {
              path: 'audit-due/:vessel_id',
              name: 'VesselAuditDueByVesselId',
              component: VesselAuditDue
            }
          ]
        },
        {
          path: 'vessels/:vessel_id/audit/:id/:type',
          name: 'AuditDetails',
          beforeEnter: async (to, from, next) => {
            const token = localStorage.getItem(TOKEN_NAME);
            if (!token) {
              return next({ name: 'Login' });
            }

            const pleaseWait = Swal.fire({
              title: 'Loading...',
              html: 'Please wait...',
              allowEscapeKey: false,
              allowOutsideClick: false,
              didOpen: () => Swal.showLoading()
            });

            try {
              await RouteInternalAuditMixin.methods.initialize(to.params);

              if (!await RouteInternalAuditMixin.methods.validateSelectedAuditType())
                return RouteInternalAuditMixin.methods.redirectToVesselList(next);

              await RouteInternalAuditMixin.methods.initializeNcr(to.name);

              if (!await RouteInternalAuditMixin.methods.validateVesselById())
                return RouteInternalAuditMixin.methods.redirectToVesselList(next);

              if (!await RouteInternalAuditMixin.methods.validateAuditReportById())
                return RouteInternalAuditMixin.methods.redirectToVesselList(next);

              if (!await RouteInternalAuditMixin.methods.validateNonConformityById())
                return RouteInternalAuditMixin.methods.redirectToVesselList(next);

              if (!await RouteInternalAuditMixin.methods.validateObjectiveEvidenceById())
                return RouteInternalAuditMixin.methods.redirectToVesselList(next);

              next();

            } finally {
              Swal.close();
            }
          },
          component: VesselAuditMain,
          children: [
            {
              path: 'internal-audit-report',
              name: 'internalAuditReport',
              component: InternalAuditReport
            },
            {
              path: 'audit-checklist',
              name: 'VesselAuditChecklist',
              component: VesselAuditChecklist
            },
            {
              path: 'non-conformity/:ncr_id/:ncr_type',
              name: 'NonConformity',
              component: NonConformity,
              children : [
                {
                  path : 'ncr-details',
                  name : 'NcrMainDetails',
                  component : NcrMainDetails,
                },
                {
                  path : 'objective-evidence/:oe_id',
                  name : 'ObjectiveEvidenceDetail',
                  component : ObjectiveEvidenceDetail,
                  children : [
                    {
                      path : 'oe-details',
                      name : 'OEMainDetails',
                      component : OEMainDetails
                    },
                    {
                      path : 'oe-attachments',
                      name : 'OEAttachments',
                      component : OEAttachments
                    },
                    {
                      path : 'company-instruction',
                      name : 'IaCompanyInstructions',
                      component : IaCompanyInstructions
                    }
                  ]
                }
              ]
            },
            {
              path: 'attachment',
              name: 'IaAttachment',
              component: IaAttachment
            },
            {
              path: 'corrective-action',
              name: 'IaCorrectiveActionReport',
              component: IaCorrectiveActionReport
            },
            {
              path: 'ship-particular',
              name: 'IAShipParticular',
              component: IAShipParticular
            },
            {
              path: 'vessel-audit-history',
              name: 'VesselAuditHistory',
              component: VesselAuditHistory
            },
            {
              path: 'appointment-details',
              name: 'AppointmentDetails',
              component: AppointmentDetails
            }
          ]
        },

      ]
    },
    {
      path : 'company-audit/',
      name : 'CompanyAudit',
      component : CompanyAudit,
      children: [
        {
          path: 'companies/',
          name: 'CompanyList',
          component: CompanyList,
        },
        {
          path: 'objective-evidence/list',
          name: 'CompanyObjectiveEvidenceList',
          component: CompanyObjectiveEvidenceList
        },
        {
          path: 'audit-due/',
          name: 'CompanyAuditDue',
          component: CompanyAuditDue,
        },
        {
          path: 'companies',
          name: 'CompanyAuditRecordMain',
          component: ()=> import('@/components/modules/ia/company/CompanyAuditRecordMain.vue'),
          children: [
            {
              path : ':company_id/audit',
              name : 'CompanyAuditRecordList',
              component: ()=> import('@/components/modules/ia/company/CompanyAuditRecordList.vue'),
            },
            {
              path: 'audit-due/:company_id',
              name: 'CompanyAuditDueByCompanyId',
              component: CompanyAuditDue
            }
          ]
        },
        {
          path: 'companies/:company_id/audit/:id/:type',
          name: 'CompanyAuditDetails',
          beforeEnter: async (to, from, next) => {
            const token = localStorage.getItem(TOKEN_NAME);
            if (!token) {
              return next({ name: 'Login' });
            }

            Swal.fire({
              title: 'Loading...',
              html: 'Please wait...',
              allowEscapeKey: false,
              allowOutsideClick: false,
              didOpen: () => Swal.showLoading()
            });

            try {

              await RouteCompanyInternalAuditMixin.methods.initialize(to.params);

              if (!await RouteCompanyInternalAuditMixin.methods.validateSelectedAuditType())
                return RouteCompanyInternalAuditMixin.methods.redirectToCompanyList(next);

              await RouteCompanyInternalAuditMixin.methods.initializeNcr(to.name);

              if (!await RouteCompanyInternalAuditMixin.methods.validateCompanyById())
                return RouteCompanyInternalAuditMixin.methods.redirectToCompanyList(next);

              if (!await RouteCompanyInternalAuditMixin.methods.validateAuditReportById())
                return RouteCompanyInternalAuditMixin.methods.redirectToCompanyList(next);

              if (!await RouteCompanyInternalAuditMixin.methods.validateNonConformityById())
                return RouteCompanyInternalAuditMixin.methods.redirectToCompanyList(next);

              if (!await RouteCompanyInternalAuditMixin.methods.validateObjectiveEvidenceById())
                return RouteCompanyInternalAuditMixin.methods.redirectToCompanyList(next);

              next();

            } finally {
              Swal.close();
            }
          },
          component: CompanyAuditMain,
          children: [
            {
              path: 'internal-audit-report',
              name: 'CompanyInternalAuditReport',
              component: CompanyInternalAuditReport
            },
            {
              path: 'non-conformity/:ncr_id/:ncr_type',
              name: 'CompanyNonConformity',
              component: CompanyNonConformity,
              children : [
                {
                  path : 'ncr-details',
                  name : 'CompanyNcrMainDetails',
                  component : CompanyNcrMainDetails,
                },
                {
                  path : 'objective-evidence/:oe_id',
                  name : 'CompanyObjectiveEvidenceDetail',
                  component : CompanyObjectiveEvidenceDetail,
                  children : [
                    {
                      path : 'oe-details',
                      name : 'CompanyOEMainDetails',
                      component : CompanyOEMainDetails
                    },
                    {
                      path : 'oe-attachments',
                      name : 'CompanyOEAttachments',
                      component : CompanyOEAttachments
                    },
                    {
                      path : 'company-instruction',
                      name : 'CompanyIaCompanyInstructions',
                      component : CompanyIaCompanyInstructions
                    }
                  ]
                }
              ]
            },
            {
              path: 'corrective-action',
              name: 'CompanyIaCorrectiveActionReport',
              component: CompanyIaCorrectiveActionReport
            },
            {
              path: 'ship-particular',
              name: 'CompanyIAShipParticular',
              component: CompanyIAShipParticular
            }
          ]
        },
      ]
    },
  ]
}
